// extracted by mini-css-extract-plugin
export var actionButton = "_cb-5";
export var actionButtonActive = "_cb-6";
export var content = "_cb-3";
export var header = "_cb-4";
export var list = "_cb-7";
export var settingsContent = "_cb-a";
export var settingsPanel = "_cb-b";
export var settingsRow = "_cb-c";
export var state = "_cb-9";
export var triggerBadge = "_cb-2";
export var triggerButton = "_cb-1";
export var triggerShell = "_cb-0";
export var unreadDot = "_cb-8";